import React from 'react';
import './FaceRecognize.scss';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import { isTranscoder1, isOriginTranscoder1 }
    from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/free-solid-svg-icons';


class FaceRecognize extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showBox: false
        };
    }

    onFaceBtnClick = () => {
        let clipId = this.props.clip.id;
        if (clipId) this.props.recognizeFace({ clipId })
    }

    componentDidMount() { }

    showFaceButton = () => {
        if (isTranscoder1() || isOriginTranscoder1())
            return (
                <div className="FaceButton">
                    <button onClick={this.onFaceBtnClick} className="FaceButton">
                        <FontAwesomeIcon icon={faSmile} />
                    </button>
                    {/* <span className="FaceIconBtn">
                        <FontAwesomeIcon onClick={this.onFaceBtnClick} icon={faSmile} />
                    </span> */}
                </div>)
    }

    render() {
        return (
            <div className="FaceRecognize">
                {this.showFaceButton()}
            </div>)
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
    clip: state.clip.currentClip,
})

const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
    recognizeFace: (obj) => dispatch(actions.recognizeFace(obj))

})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FaceRecognize));